import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { NgForm, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppSettings } from '../../app.constant';
import { UserService } from '../../shared/services/user.service';
import { HttpErrorResponse, HttpClient } from '@angular/common/http';
import { User } from '../../shared/interface/user';
import { Router } from "@angular/router";

@Component({
  selector: 'login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  providers: [UserService]
})

export class LoginComponent implements OnInit {
  UserName: string;
  Password: string;
  loginForm: FormGroup;
  submitted = false;
  post: any;
  errorMessage: String;
  httpResponseMessage: any;
  // User: Observable<User[]>;  

  constructor(private router: Router,
    private FormBuilder: FormBuilder,
    private UserService: UserService,
    private snackBar: MatSnackBar, ) { }

  ngOnInit() {
    this.loginForm = this.FormBuilder.group({
      'UserName': ['', Validators.required],
      'Password': ['', Validators.required]
    })


  }

  onSubmit() {
    this.submitted = true;
    if (this.loginForm.invalid) {
      return;
    }
    alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.loginForm.value))
  }

  userLogin(post): void {
    this.post = JSON.stringify(post);
    this.UserService.getUserData(AppSettings.API_ENDPOINT + AppSettings.GetUserData, this.post).subscribe(
      data => {
        if (data != null) {
          sessionStorage.setItem('UserName', data[0].FirstName);
          sessionStorage.setItem('Role', data[0].FK_RoleID);
          this.router.navigate(['/dashboard']);
        }
        else {

        }
      },
      error => {
        console.log(error.error);
        this.httpResponseMessage = error.error;
        this.openSnackBar(this.httpResponseMessage, '');
      })


  }

  durationInSeconds = 2;
  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 2000,
      verticalPosition: 'bottom'
    });
  }
}